import axios from "axios";

export const FOTO_TOKEN_KEY = "pgp_foto_token";
export const FOTO_DEVICE_KEY = "pgp_foto_device";

export const fotoApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/foto` });
fotoApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(FOTO_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const fotoError = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d === "session_superseded" ? "Sessione scaduta, accedi di nuovo." : d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "Errore di connessione. Riprova.";
};
